export default __webpack_public_path__ + "static/media/sorry.ff838085.png";